"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { DomainConfig } from "@/lib/domain-config";

const DomainConfigContext = createContext<DomainConfig | null>(null);

export function DomainConfigProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: DomainConfig;
}) {
  return (
    <DomainConfigContext.Provider value={value}>
      {children}
    </DomainConfigContext.Provider>
  );
}

export function useDomainConfigContext() {
  return useContext(DomainConfigContext);
}
